const fetch = (function( $ ) {
	const setup = {
		init(){
			$.ajaxSetup({
		  		data: {
		  			secure: ajax_nonce
		  		},

		  		context:this.methods,
				dataType:'json'
			});
		}
	};

	const methods = {
		_fetch(method, action, data){
			console.info('ENVOI : ' + action);
			console.group(data)
			console.groupEnd();
			var dfd = jQuery.Deferred();
			$.ajax({
				method: method,
				url: ajax_url,
				data:{
					action,
					data
				}
			})
			.done(function( data ) {
				console.info('RESULT : ' + action)
				console.group(data)
				console.groupEnd();
			    dfd.resolve(data);
			})
			.fail(function(jqXHR, textStatus, errorThrown){
				dfd.reject(jqXHR.responseJSON);
			});

			return dfd.promise();
		},

		getScript(source){
			return new Promise(function(resolve, reject) {
		        let script = document.createElement('script');
		        const prior = document.getElementsByTagName('script')[0];
		        script.async = 1;
		        prior.parentNode.insertBefore(script, prior);
		        script.onerror = reject;
		        script.onload = script.onreadystatechange = function(_, isAbort) {
		            if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
		                script.onload = script.onreadystatechange = null;
		                script = undefined;

		                if (!isAbort) {
		                    resolve();
		                }
		            }
		        };

		        script.src = source;
		    });
		},

		connexion(info){
			return this._fetch('POST', 'login', info)
		},

		logout(){
			return this._fetch('POST', 'logout')
		},

		inscription(info){
			return this._fetch('POST', 'postInscription', info)
		},

		getEvenement(info){
			return this._fetch('POST', 'getEvenement', info)
		},

		postEvenement(info){
			return this._fetch('POST', 'postEvenement', info)
		},

		deleteEvenement(info){
			return this._fetch('POST', 'deleteEvenement', info)
		},
		getUsers(info){
			return this._fetch('POST', 'getUsers', info)
		},
		partageUser(info){
			return this._fetch('POST', 'partageUser', info)
		},
		getAgendasUser(info){
			return this._fetch('POST', 'getAgendasUser', info)
		},
		getAgendasUserPartagerAvec(info){
			return this._fetch('POST', 'getAgendasUserPartagerAvec', info)
		},
		deleteAgendaUser(info){
			return this._fetch('POST', 'deleteAgendaUser', info)
		}
	}
	setup.init();

	return methods;

})(jQuery)